"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.statisticsListApi = statisticsListApi;
exports.statisticsSummaryApi = statisticsSummaryApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 统计 获取商品列表
 */
function statisticsListApi(params) {
  return (0, _request.default)({
    url: 'admin/statistics/product/list',
    method: 'get',
    params: params
  });
}

/**
 * 统计 获取汇总数据
 */
function statisticsSummaryApi(params) {
  return (0, _request.default)({
    url: 'admin/statistics/product/summary',
    method: 'get',
    params: params
  });
}